import { actions as formActions } from 'react-redux-form'

import * as h2Api from '../h2Api'

export const LOAD = 'COLLEGE_PREFERENCES_LOAD'
export const UPDATE = 'COLLEGE_PREFERENCES_UPDATE'
export const UPDATE_META = 'COLLEGE_PREFERENCES_UPDATE_META'
export const LOAD_OPTIONS = 'COLLEGE_PREFERENCES_LOAD_OPTIONS'

const updateFormValues = prefs => dispatch => {
  const selectivity = {
    actMin: prefs.actMin || 0,
    actMax: prefs.actMax || 36,
    satMin: prefs.satMin || 400,
    satMax: prefs.satMax || 1600
  }

  dispatch(formActions.merge('collegePreferences.forms.selectivity', selectivity))
  const financial = {
    stateOfResidence: prefs.stateOfResidence || '',
    parentSalaryRange: prefs.parentSalaryRange || '',
    savings: prefs.savings || '',
    cost: prefs.cost || ''
  }

  dispatch(formActions.merge('collegePreferences.forms.financial', financial))
}

export const loadPreferences = () => dispatch => {
  return dispatch(h2Api.get('/college_preferences')({ type: LOAD })).then(prefs => {
    dispatch(updateFormValues(prefs))

    return prefs
  })
}

export const updatePreferences = preferences => dispatch => {
  return dispatch(h2Api.post('/college_preferences', preferences)({ type: UPDATE })).then(
    prefs => {
      return prefs
    }
  )
}

export const updateMeta = newValues => dispatch => {
  return dispatch({ type: UPDATE_META, newValues })
}

export const loadOptions = () => dispatch => {
  return dispatch(h2Api.get('/college_preferences/options')({ type: LOAD_OPTIONS }))
}
